import React from 'react';
import { Campaign } from '~/api/models/campaign';
import { Divider } from '@rio-cloud/rio-uikit';
import { toShortSemanticVersion } from '~/features/base/utils/versionNumberConverter';
import { FormattedMessage } from 'react-intl';

interface CampaignTargetDeliverableSectionProps {
    campaign: Campaign;
    onEditClick: () => void;
}

const CampaignTargetDeliverableSection: React.FC<CampaignTargetDeliverableSectionProps> = ({
    campaign,
    onEditClick
}) => {

    return (
        <div className={'height-100pct'}>
            <div className='display-flex align-items-center justify-content-between'>
                <span className='title margin-right-10'><FormattedMessage
                    id={'intl-msg:campaign:targetDeliverable'}/></span>
                <button
                    className='btn btn-link margin-left-10 padding-0'
                    onClick={onEditClick}
                >
                    <span className='rioglyph rioglyph-pencil'></span>
                </button>
            </div>
            <div className='display-flex align-items-center'>
                <Divider className='width-100pct padding-top-0'/>
            </div>

            <div className='margin-top-15'>
                <div className='row margin-bottom-10'>
                    <div className='col-4'>
                        <div className='text-color-gray'><FormattedMessage id={'intl-msg:deliverableType'}/></div>
                        <div>{campaign?.deliverableType || <span className='text-color-gray'>—</span>}</div>
                    </div>
                    <div className='col-8'>
                        <div className='text-color-gray'><FormattedMessage id={'intl-msg:deliverableId'}/></div>
                        <div>{campaign?.deliverableId || <span className='text-color-gray'>—</span>}</div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <div className='text-color-gray'><FormattedMessage
                            id={'intl-msg:reportsBillingDeliverableVersion'}/></div>
                        <div>{toShortSemanticVersion(campaign?.deliverableVersion) ||
                            <span className='text-color-gray'>—</span>}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignTargetDeliverableSection;
